module.exports = __webpack_public_path__ + "img/ja.1dbf51e2.svg";